/**
 * An override to easily switch the the "sourceless iframe inside" code to come from a test location
 * (rather than the URL specified in the "sourcelessIframeBundleUrl" parameter of "loadComponentInSourcelessIframe").
 **/
export const sourcelessIframeUrl = 'sourcelessIframeUrl';

/**
 * An override for loading a special flavor of the "iframe-inside" code
 * (Only relevant if loading the iframe-inside from our CDN, rather than host-served files)
 */
export const sourcelessIframeFlavor = 'sourcelessIframeFlavor';
